const BaseComponent = require('base/base-component');

class Search extends BaseComponent {
  constructor () {
    super({
      events: {
        'input .mainkeyword': 'showClear',
        'click .icon-Shape': 'clear',
        'keydown .mainkeyword': 'handleSearch',
        'click .Jsearch': 'handleSearch'
      }
    });
    this.$input = this.$el.find('.mainkeyword');
  }

  clear (e) {
    this.$input.val('');
    $(e.target).hide();
  }

  handleSearch (e) {
    if(e.type === 'keydown' && e.keyCode !== 13) return;
    let keyword = this.$input.val();
    location.href = `/full/search.html?k=${encodeURIComponent(keyword)}`;
  }

  showClear (e) {
    const $ele = $(e.target || e.srcElement);
    if ($ele.val().length > 0) {
      this.$el.find('.icon-Shape').show();
    } else {
      this.$el.find('.icon-Shape').hide();
    }
  }
}
module.exports = Search;
